<script setup>
import { useI18n } from 'vue-i18n';
import { inject } from 'vue';

// Components
import Checkbox from '@/Components/Checkbox.vue';

const props = defineProps({
    modelValue: Object,
    categoryOptions: Object,
});

const { t } = useI18n();
const route = inject('route');
const emits = defineEmits(['update:modelValue']);

function categoryIsActive(category) {
    return typeof props.modelValue.find((catId) => catId == category.id) !== 'undefined';
}

function clickOnCategory(cat) {
    if (categoryIsActive(cat)) {
        emits(
            'update:modelValue',
            props.modelValue.filter((id) => id != cat.id)
        );
    } else {
        emits('update:modelValue', [...props.modelValue, cat.id]);
    }
}
</script>

<template>
    <div class="flex mt-6">
        <div class="flex flex-col flex-wrap mb-15">
            <p class="mb-3 text-lg font-bold">{{ t('Type job position') }}</p>

            <Checkbox
                v-for="cat in categoryOptions"
                :key="cat.id"
                :label="cat.name"
                @click="clickOnCategory(cat)"
                :active="categoryIsActive(cat)"
            ></Checkbox>
        </div>
    </div>
</template>
